<template>
  <div>
    <div class="execon">
      <Row type="flex" v-if="pageTotal == 0" style="text-align: center;">
        <Col span="24"><img class="emptyImg" src="/static/images/empty.png" alt=""></Col>
        <Col span="24" style="margin-top:20px;">暂时没有相关内容～</Col>
      </Row>
      <div class="question" v-else v-for="(item,index) in packageList" :key="index" style="margin-bottom:15px;">
        <div class="exequcon">
          <div class="left">{{index+1}}</div>
          <div class="execontent" v-if="item.qstSetofQuestion == 0">
            <div class="stem" v-html="item.packageQuestionContent.qstcContentTxt">{{item.packageQuestionContent.qstcContentTxt}}</div>
            <div class="option">
              <div class="opitem" v-if="item.packageQuestionContent.qstcOptionA != null && item.packageQuestionContent.qstcOptionA != ''">A.<span v-html="item.packageQuestionContent.qstcOptionA">{{item.packageQuestionContent.qstcOptionA}} </span></div>
              <div class="opitem" v-if="item.packageQuestionContent.qstcOptionB != null && item.packageQuestionContent.qstcOptionB != ''">B.<span v-html="item.packageQuestionContent.qstcOptionB">{{item.packageQuestionContent.qstcOptionB}} </span></div>
              <div class="opitem" v-if="item.packageQuestionContent.qstcOptionC != null && item.packageQuestionContent.qstcOptionC != ''">C.<span v-html="item.packageQuestionContent.qstcOptionC">{{item.packageQuestionContent.qstcOptionC}} </span></div>
              <div class="opitem" v-if="item.packageQuestionContent.qstcOptionD != null && item.packageQuestionContent.qstcOptionD != ''">D.<span v-html="item.packageQuestionContent.qstcOptionD">{{item.packageQuestionContent.qstcOptionD}} </span></div>
              <div class="opitem" v-if="item.packageQuestionContent.qstcOptionE != null && item.packageQuestionContent.qstcOptionE != ''">E.<span v-html="item.packageQuestionContent.qstcOptionE">{{item.packageQuestionContent.qstcOptionE}} </span></div>
              <div class="opitem" v-if="item.packageQuestionContent.qstcOptionF != null && item.packageQuestionContent.qstcOptionF != ''">F.<span v-html="item.packageQuestionContent.qstcOptionF">{{item.packageQuestionContent.qstcOptionF}} </span></div>
            </div>
          </div>
          <div class="execontent" v-if="item.qstSetofQuestion == 1">
            <div class="stem" v-html="item.packageQuestionContent.qstcContentTxt">{{item.packageQuestionContent.qstcContentTxt}}</div>
          </div>
        </div>
        <div :class="item['isJiexi'+index]?'yesColor lookjx':'noColor lookjx'" @click="showSreen(index)">
            <div class="kong"></div>
            <div class="lookicon">
              <img src="/static/images/jiexibg.png" v-show="item['isJiexi'+index]" alt="">
              <img src="/static/images/jiexi.png" v-show="!item['isJiexi'+index]"alt="">
              查看解析</div>
         </div>
        <div class="jiexi" v-show="item['isJiexi'+index]" >
            <div class="kong"></div>
            <div class="jiexicon">
             答案： <div v-html="item.packageQuestionContent.qstcAnswerTxt">{{item.packageQuestionContent.qstcAnswerTxt}}</div>
              解析：<div v-html="item.packageQuestionContent.qstcAnalyticTxtOne">{{item.packageQuestionContent.qstcAnalyticTxtOne}}</div>

            </div>
        </div>
      </div>
    </div>
    <div class="page" v-if="pageTotal !=0">
         <Page :total="pageTotal" :page-size="12" @on-change="changePage"/>
    </div>
  </div>
</template>

<script>
  import api from '../../utils/api.js';
  import bus from '../../assets/eventBus/enentBus.js';
  export default {
    name: 'PrepareVideo',
    props:{
      prepareData: { //同步资源
        type: Object,
        defalut: null
      }
    },
    data() {
      return {
        pageTotal:null,
        urlHttp:'/testIp',
        packageList:null,
        imgurl:'https://qcban.aixuetang.com/res/',              //微课图片地址  线上域名
        isOpenImgSrc:'/static/images/jiexi.png',
        isOpenScreen:true,
        isJiexi:false
      }
    },
    watch: {
      prepareData: {
          handler: function(newVal,oldVal) {
            this.getSectionVideoList(1);
          },
          deep: true
        }
    },
    mounted() {
        const that = this;
        this.getSectionVideoList(1);
      },
      methods:{
        //获取习题列表
        getSectionVideoList(page){
          const that = this;
          const url =  '/axt-resources/package_prepare/pageQuestion';
          var params = {
              packageCourseId:that.prepareData.packageId,
              packageChapterId:that.prepareData.chapterId,
              packageLectureId:that.prepareData.lectureId,
              packageSectionId:that.prepareData.sectionId,
              useType: 0,
              orderBys: [{
              		direction: 'asc',
              		field: 'sort_id'
              }],
              showUseType: true,
              pageNo: page,
              pageSize: 12,
              qstAutoJudge: null,
              qstShowType :3
          };
          //console.log(params)
          api.postFormAPI(url,params).then(res => {
            //数据处理
            console.log(res)
            that.pageTotal = res.data.data.total;                   //分页总数
            that.packageList = res.data.data.rows;
            for(let i = 0;i<that.packageList.length;i++){
              let isJiexi = "isJiexi"+i;
              that.packageList[i][isJiexi] = false;
            }
           // console.log('packageList',that.packageList)


          }).catch(err => {
            console.log(err)
          })
        },
        //翻页
        changePage(page){
            const that = this;
            this.getSectionVideoList(page);
        },
        //查看解析
        showSreen(obj){
           let isJiexi = "isJiexi"+obj;
           let arr = this.packageList[obj];
            arr[isJiexi] = !arr[isJiexi]
            this.packageList.splice(obj,1,arr);
             //console.log('是否显示',this.packageList[obj][isJiexi])
        }
    }
  }

</script>

<style>
  .execon .question {
    border-bottom: 2px solid #F2F2F2;
    padding: 15px 15px 15px 0;
    background: #F3F5FA;
    border-radius: 10px;
    margin-bottom: 20px;
    line-height: 1.8;
  }
  .execon .question .exequcon {
    display:flex;
    flex-direction: row;
  }
  .execon .left {
    flex:1;
    font-size: 34px;
    font-weight: 500;
    text-align: center;
    color: #4357F2;
  }
  .execontent {
    flex:11;
    text-align: left;
  }
  .option .opitem {
    display: flex;flex-direction: row;
  }
  .lookjx {
    text-align: left;
    display:flex;
    flex-direction: row;
    margin-top: 15px;
    cursor: pointer;
    font-size: 14px;
  }
  .jiexi {
    text-align: left;
    display:flex;
    flex-direction: row;
  }
  .kong {
    flex:1;
  }
  .lookicon, .jiexicon {
    flex:11;
  }
  .lookicon img {
    height: 13px;
    margin-right: 7px;
  }
  .yesColor{
    color:#4357F2;
  }
  .noColor{
    color:#7F7F7F;
  }
</style>



// WEBPACK FOOTER //
// src/components/PrepareDetail/PrepareExercises.vue